import { Routes } from 'types/routes';

export const ROUTES_FOR_DYNAMIC_REFRESH: string[] = [
    Routes.PublicBlogCategory,
    Routes.PublicBlogArticle,
    Routes.PublicCategoryLocation,
];